import {
  PageNavbarItem,
  PageNavbar,
} from "@core/components/layout/page-navbar";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useAuthContext } from "@/providers/auth-provider";
import { isEmployeeUserWithEmployeeRole } from "creso-core/utils";
import { Page } from "@core/components/layout/page";

export const Route = createFileRoute("/(auth)/_headed/reports/_layout")({
  component: RouteComponent,
});

function RouteComponent() {
  const { user } = useAuthContext();

  return (
    <Page className="flex flex-col bg-background rounded-lg size-full overflow-hidden">
      <Page.Content>
        <PageNavbar className="sticky top-0 z-2 bg-background">
          {!isEmployeeUserWithEmployeeRole(user) && (
            <PageNavbarItem to="/reports/brokerage">
              Brokerage Reports
            </PageNavbarItem>
          )}
          <PageNavbarItem to="/reports/change-of-broker">
            Change of Broker
          </PageNavbarItem>
        </PageNavbar>
        <Outlet />
      </Page.Content>
    </Page>
  );
}
